import { Directive, Input } from '@angular/core';
import { QueryDetailBuilderComponent } from 'src/app/query/query-detail/query-detail-builder/query-detail-builder.component';
import { QueryTreeNodeModel } from './query-tree-node.model';

@Directive()
export class QueryEditorBase {
  @Input()
  node: QueryTreeNodeModel;

  @Input()
  queryBuilder: QueryDetailBuilderComponent;

  @Input()
  isReadonly: boolean;

  currentQueryId: number;

  baseCssClass = 'query-tree-node-wrapper query left-bordered';
  baseCssClassReadonly = 'query-tree-node-wrapper-readonly query left-bordered';

  get cssClass(): string {
    return this.isReadonly
      ? this.baseCssClassReadonly + ' ' + this.node.category.cssClass
      : this.baseCssClass + ' ' + this.node.category.cssClass;
  }

  get text(): string {
    return this.node.categoryItem.title;
  }

  get regexTerm(): RegExp {
    return /^[a-zA-ZığüşöçĞÜŞÖÇİ ]*$/;
  }

  get showMoveIcon(): boolean {
    let found = 0;
    const stack = [...this.queryBuilder.treeData];

    while (stack.length) {
      const n = stack.pop()!;
      if (n.categoryItem.dataType === this.queryBuilder.queryFieldDataType.QueryGroup) {
        found++;
        if (found > 1) return true; 
      }
      if (n.children?.length) {
        stack.push(...n.children);
      }
    }

    return false;
  }

  get movingNode(): QueryTreeNodeModel | null {
    return this.queryBuilder.movingNode;
  }

  get canMoveHere(): boolean {
    return this.queryBuilder.isValidTarget(this.node);
  }

  onStartMove(event: MouseEvent): void {
    event.stopPropagation();
    this.queryBuilder.startMove(this.node);
  }

  onMoveHereClick(event: MouseEvent): void {
    event.stopPropagation();
    this.queryBuilder.confirmMove(this.node);
  }

  removeNode(eventArgs) {
    this.queryBuilder.removeNode(this.node.categoryItem.payload.internalId);
  }

  onClickDuplicate(eventArgs: MouseEvent): void {
    this.queryBuilder.duplicateNode(this.node.categoryItem.payload.internalId);
  }

  constructor() {}
}
